module.exports = __webpack_public_path__ + "static/campaign-3-eb5123979397690cb291e635f36a0fb5.png";